module.exports = __webpack_public_path__ + "img/erlun.0e5db396.png";